import moment from "moment";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { CallAPI } from "./apiActions";
import {
  AFFILIATE_ACTIVITY,
  CHAT_HISTORY_FETCH,
  GENERIC_FILE_UPLOAD,
  GET_PARENT_AGENCY_INFO,
  GET_SITE_INFO,
  GET_SOCIALMEDIA_INFO,
} from "./APIEndPoints";
import {
  guestRoute,
  hiddenPath,
  menuDynamicRoute,
  menuStaticRoute,
  paginationObj,
} from "./constant";
import CryptoJS from "crypto-js";
import useChatBot from "../hooks/useChatBot";

dayjs.extend(customParseFormat);

const secretKey = process.env.REACT_APP_SECRET_KEY;

// export const createLinkText = (text, color="blue") => {
//   const regex = /(https?:\/\/[^\s]+)/g; // Detect URLs
//   const parts = text?.split(regex);

//   // parts?.forEach((part) => {
//   //   if (part.match(regex)) {
//   //     window.open(part, "_blank", "noopener,noreferrer");
//   //   }
//   // });

//   // Return the same text with links rendered (optional)
//   console.log("color", color)
//   return parts?.map((part, index) => {
//     if (part.match(regex)) {
//       return (
//         <a
//           style={{ color: color}}
//           key={index}
//           href={part}
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           {part}
//         </a>
//       );
//     } else {
//       return part;
//     }
//   });
// };

export const createLinkText = (text, color = "blue") => {
  // console.log(text, "d");
  const regex = /(https?:\/\/[^\s]+)/g; // Detect URLs
  const parts = text?.split(regex);

  return parts?.map((part, index) => {
    if (part.match(regex)) {
      return (
        <a
          style={{ color }}
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
        >
          {part}
        </a>
      );
    } else {
      // Render HTML properly
      return <span key={index} dangerouslySetInnerHTML={{ __html: part }} />;
    }
  });
};

export const getAgencySettings = async (parentAgency = null) => {
  let data = parentAgency
    ? { agencyId: localStorage.getItem("parentUserRefferId") || parentAgency }
    : {};
  let response = await CallAPI(
    "USER",
    "POST",
    `${GET_PARENT_AGENCY_INFO}`,
    data,
  );
  if (response.status) {
    return Promise.resolve(response);
  }
};

export const handleGenericFileUpload = async (data) => {
  const formData = new FormData();
  if (!!data.shortCode) {
    formData.append("shortCode", data.shortCode);
  }
  formData.append("file", data.file);
  let response = await CallAPI(
    "USER",
    "POST",
    GENERIC_FILE_UPLOAD,
    formData,
    "file",
  );
  console.log("response 1111------", response);
  // if (response.status) {
  return Promise.resolve(response);
  // }
};

export const getInvitationUserList = async (
  paginationData,
  filterParams,
  invitationType,
) => {
  let URL = `${AFFILIATE_ACTIVITY.REFERRALS_LIST}?page=${paginationData.currentPage}`;
  if (filterParams.status) {
    URL = `${URL}&status=${filterParams.status}`;
  }
  if (!!filterParams.fromDate && !!filterParams.toDate) {
    URL = `${URL}&fromDate=${moment(filterParams.fromDate).format(
      "YYYY-MM-DD",
    )}&toDate=${moment(filterParams.toDate).format("YYYY-MM-DD")}`;
  }
  if (!!invitationType) {
    URL = `${URL}&invitationType=${invitationType}`;
  }
  let response = await CallAPI("USER", "GET", URL);
  if (response.status) {
    return Promise.resolve({
      totalInvitation: response.res.data.data,
      totalRecords: response?.res?.data?.pagination?.totalRecords,
      totalPages: Math.ceil(
        response?.res?.data?.pagination?.totalRecords /
          paginationObj.item_per_page,
      ),
    });
  }
};

export const getSiteInfo = async (parentAgency = null) => {
  let data = parentAgency ? { agencyId: parentAgency } : {};
  let response = await CallAPI("USER", "POST", `${GET_SITE_INFO}`, data);
  if (response.status) {
    return Promise.resolve(response);
  }
};

export const getSocialMediaLink = async (parentAgency = null) => {
  let data = parentAgency ? { agencyId: parentAgency } : {};
  let response = await CallAPI("USER", "POST", `${GET_SOCIALMEDIA_INFO}`, data);
  if (response.status) {
    return Promise.resolve(response);
  }
};

// export const handleRestriction = (user, accessType, menu, type = null) => {
//   console.log("user menu", user, menu, accessType)
//   let route = '/'
//   if (accessType === 1) {
//     if (type == "route") {
//       route = menu.includes('admin/') ? menu : `admin${menu}`
//     }
//     else {
//       route = menuDynamicRoute[menu]?.route[0]
//     }
//     return route
//   }
//   else if (accessType === 3) {
//     if (user?.subscriptionStatus === 0 && user.userType != 6) {
//       return "/agency/plan-list"
//     }
//     else if (((user?.subscriptionStatus === 2 && user?.isGracePeriod == 2) || user?.subscriptionStatus === 3) && user.userType != 6) {
//       if (type == "route" && menu.includes('/plan-list')) {
//         route = menu.includes('agency/') ? menu : `agency${menu}`
//         return "/agency/plan-list"
//       }
//       return "/agency/my-plan"
//     }
//     else {
//       if (user?.isAccountOnboarding == 1 || menu == "my-subscription" || menu == "/agency/my-plan" || user.userType == 6) {
//         if (!!user?.logoLink || menu == "my-subscription" || menu == "/agency/my-plan" || menu == "my-payment-account-details" || menu == "/agency/payment-management" || user.userType == 6) {
//           if (type == "route") {
//             route = menu.includes('agency/') ? menu : `agency${menu}`
//           }
//           else {
//             route = menuDynamicRoute[menu]?.route[2]
//           }
//           console.log("user menu111", route)
//           return route
//         }
//         else {
//           return "/agency/branding-management"
//         }
//       }
//       else {
//         return '/agency/payment-management'
//       }
//     }
//   }
//   else if (accessType === 2 || accessType === 4) {
//     if (user?.subscriptionStatus === 0 && user.userType != 6) {
//       return "/plan-list"
//     }
//     else {
//       if (type == "route") {
//         route = menu
//       }
//       else {
//         route = menuDynamicRoute[menu]?.route[1]
//       }
//       return route
//     }
//   }
//   else if (accessType === 5) {
//     if (user?.isAccountOnboarding != 1 && user.userType != 6) {
//       return "/affiliate/payment-management"
//     }
//     else {
//       if (type == "route") {
//         route = menu.includes('affiliate/') ? menu : `affiliate${menu}`
//       }
//       else {
//         route = menuDynamicRoute[menu]?.route[3]
//       }
//       return route
//     }
//   }
// } //backup upto Milon start working in same function
export const handleRestriction = (user, accessType, menu, type = null) => {
  console.log(` menu=${menu} accessType=${accessType}`);
  let route = "/";
  if (accessType === 1) {
    if (type == "route") {
      route = menu.includes("admin/") ? menu : `admin${menu}`;
    } else {
      route = menuDynamicRoute[menu]?.route[0];
    }
    return route;
  } else if (accessType === 3) {
    if (user?.subscriptionStatus === 0 && user.userType != 6) {
      return "/agency/plan-list";
    } else if (
      ((user?.subscriptionStatus === 2 && user?.isGracePeriod == 2) ||
        user?.subscriptionStatus === 3) &&
      user.userType != 6
    ) {
      if (type == "route" && menu.includes("/plan-list")) {
        route = menu.includes("agency/") ? menu : `agency${menu}`;
        return "/agency/plan-list";
      }
      return "/agency/my-plan";
    } else if (user?.isGracePeriod == 3) {
      if (type == "route" && menu.includes("/plan-list")) {
        route = menu.includes("agency/") ? menu : `agency${menu}`;
        return "/agency/plan-list";
      }
      return "/agency/my-plan";
    } else {
      if (
        user?.isAccountOnboarding == 1 ||
        menu == "my-subscription" ||
        menu == "/agency/my-plan" ||
        user.userType == 6
      ) {
        if (
          !!user?.logoLink ||
          menu == "my-subscription" ||
          menu == "/agency/my-plan" ||
          menu == "my-payment-account-details" ||
          menu == "/agency/payment-management" ||
          user.userType == 6
        ) {
          if (type == "route") {
            route = menu.includes("agency/") ? menu : `agency${menu}`;
          } else {
            route = menuDynamicRoute[menu]?.route[2];
          }
          console.log("user menu111", route);
          return route;
        } else {
          return "/agency/branding-management";
        }
      } else {
        return "/agency/payment-management";
      }
    }
  } else if (accessType === 2 || accessType === 4) {
    if (user?.subscriptionStatus === 0 && user.userType != 6) {
      return "/plan-list";
    } else if (user?.subscriptionStatus !== 1 && user.userType !== 6) {
      return "/my-plan";
    } else {
      if (type == "route") {
        route = menu;
      } else {
        route = menuDynamicRoute[menu]?.route[1];
      }
      return route;
    }
  } else if (accessType === 5) {
    if (user?.isAccountOnboarding != 1 && user.userType != 6) {
      return "/affiliate/payment-management";
    } else {
      if (type == "route") {
        route = menu.includes("affiliate/") ? menu : `affiliate${menu}`;
      } else {
        route = menuDynamicRoute[menu]?.route[3];
      }
      return route;
    }
  }
};
export const getRouteIndex = (userType) => {
  return userType == 1
    ? 0
    : userType == 2 || userType == 4
      ? 1
      : userType == 3
        ? 2
        : 3;
};

export const getFirstAccessibleMenuName = (user, accessType) => {
  const routeIndex = getRouteIndex(accessType);

  return user?.menus?.find(
    (menu) =>
      menu?.permissions?.view &&
      menuDynamicRoute[menu?.menuName]?.route?.[routeIndex],
  )?.menuName;
};

export const hasMenuPermission = (
  user,
  menuName,
  permissionType = "view",
) => {
  const menu = user?.menus?.find((item) => item?.menuName === menuName);
  return Boolean(menu?.permissions?.[permissionType]);
};

export const getDefaultAuthorizedRoute = (user, accessType) => {
  const routeIndex = getRouteIndex(accessType);
  const firstAccessibleMenuName = getFirstAccessibleMenuName(user, accessType);

  if (firstAccessibleMenuName) {
    return menuDynamicRoute[firstAccessibleMenuName].route[routeIndex];
  }

  return menuDynamicRoute.dashboard?.route?.[routeIndex] || "/dashboard";
};

export const permittedRoute = (location, accessType, user) => {
  console.log("permittedRoute----", location);
  let exactPath = location;
  let pathVariables;
  let flag = true;
  if (!!user) {
    if (location.includes("/admin")) {
      if (accessType != 1) {
        flag = false;
      }
      pathVariables = location.split("/admin")[1].split("/");
    } else if (location.includes("/agency")) {
      if (accessType != 3) {
        flag = false;
      }
      pathVariables = location.split("/agency")[1].split("/");
    } else if (location.includes("/affiliate")) {
      if (accessType != 5) {
        flag = false;
      }
      pathVariables = location.split("/affiliate")[1].split("/");
    } else {
      if (accessType != 2 && accessType != 4) {
        flag = false;
      }
      pathVariables = location.split("/");
    }
    console.log("permittedRoute----", pathVariables);
    exactPath = pathVariables[2]
      ? `${pathVariables[1]}/${pathVariables[2]}`
      : pathVariables[1];
  }
  if (!!guestRoute?.includes(exactPath)) {
    return `/${exactPath}`;
  }
  console.log(
    "permittedRoute----",
    exactPath,
    location,
    pathVariables,
    menuStaticRoute,
  );
  let result = {};
  menuStaticRoute.forEach((item) => {
    const key = Object.keys(item)[0]; // Extract the key
    result[key] = item[key]; // Assign the value to the result object
  });
  if (!!result[exactPath] && !!flag) {
    console.log("permittedRoute0----", result[exactPath]);
    return result[exactPath].route[getRouteIndex(accessType)];
  } else if (!!user?.routes[exactPath] && !!flag) {
    console.log(
      "permittedRoute1----",
      handleRestriction(user, accessType, location, "route"),
    );
    return handleRestriction(user, accessType, location, "route");
  } else if (!!hiddenPath?.includes(exactPath) && !!flag) {
    if (
      user?.userType === 6 &&
      ["plan-list", "my-plan"].includes(exactPath) &&
      !hasMenuPermission(user, "my-subscription")
    ) {
      return getDefaultAuthorizedRoute(user, accessType);
    }

    return location;
  } else {
    // return "/400"
    const fallbackMenuName = getFirstAccessibleMenuName(user, accessType);
    console.log(
      "permittedRoute2----",
      fallbackMenuName,
      menuDynamicRoute[fallbackMenuName]?.route[getRouteIndex(accessType)],
    );
    return (
      menuDynamicRoute[fallbackMenuName]?.route[getRouteIndex(accessType)] ||
      getDefaultAuthorizedRoute(user, accessType)
    );
  }
};

export const handleNavigate = (navigate, currentPath, prevPath) => {
  console.log("handleNavigate", currentPath, prevPath);
  if (currentPath !== prevPath) {
    navigate(currentPath);
  }
};

export const maskString = (str) => {
  if (str.length <= 4) {
    return str;
  }
  let maskedString = str
    .split("")
    .map((char, index) => {
      if (index < str.length - 4 && char !== " ") {
        return "X";
      }
      return char;
    })
    .join("");

  return maskedString;
};

export const encryptData = (payload) => {
  const ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(payload),
    secretKey,
  ).toString();
  console.log("Data 111:", payload, ciphertext);
  return ciphertext;
};

export const decryptData = (ciphertext) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
  // const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  console.log("Data 222:", ciphertext, decryptedData);
  return decryptedData;
};

export const getTokenWithExpirationCheck = (shortCode) => {
  const tokenData = JSON.parse(localStorage.getItem("chatBotToken"));
  if (!tokenData) {
    return null;
  }
  const currentTime = new Date().getTime();
  console.log("token data", tokenData.connectedShortCode, shortCode);
  if (
    currentTime > tokenData.expiration ||
    tokenData.connectedShortCode != shortCode
  ) {
    localStorage.removeItem("chatBotToken");
    return null;
  }
  return tokenData;
};

const aesKey = CryptoJS.enc.Utf8.parse("12345678901234567890123456789012");
const keyBytes = CryptoJS.enc.Hex.parse(aesKey);
const iv = CryptoJS.lib.WordArray.random(16);

// AES-256-CBC Encryption
export const encryptJsonDataNode = (jsonData) => {
  const data = CryptoJS.enc.Utf8.parse(jsonData);

  // Apply PKCS7 padding automatically
  const encrypted = CryptoJS.AES.encrypt(data, keyBytes, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: iv,
  });

  // Convert to Base64
  const encryptedPayload = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  const ivBase64 = CryptoJS.enc.Base64.stringify(iv);

  return ivBase64 + ":" + encryptedPayload;
};

// AES-256-CBC Decryption
export const decryptJsonDataNode = (encryptedPayload) => {
  try {
    const parts = encryptedPayload.split(":");
    if (parts.length !== 2) {
      throw new Error("Invalid encrypted payload format");
    }

    const ivBase64 = parts[0];
    const encryptedDataBase64 = parts[1];

    // Decode IV and encrypted data from Base64
    const iv = CryptoJS.enc.Base64.parse(ivBase64);
    const encryptedData = CryptoJS.enc.Base64.parse(encryptedDataBase64);

    // Decrypt using AES-CBC
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedData },
      keyBytes,
      { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, iv: iv },
    );

    // Convert decrypted data to string
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    if (!decryptedText) {
      throw new Error("Decryption failed or resulted in an empty string.");
    }

    // Attempt to parse JSON if applicable
    try {
      return JSON.parse(decryptedText); // Convert back to JSON object if valid JSON
    } catch (jsonError) {
      return decryptedText; // Return as a string if it's not JSON
    }
  } catch (error) {
    console.error("Decryption Error:", error.message);
    return { error: error.message };
  }
};

const aesKeyPython = CryptoJS.SHA256(secretKey).toString(CryptoJS.enc.Hex);
const keyBytesPython = CryptoJS.enc.Hex.parse(aesKeyPython);
const ivPython = CryptoJS.enc.Utf8.parse("1234567890123456");

// AES-256-CBC Encryption
export const encryptJsonDataPython = (jsonData) => {
  const data = CryptoJS.enc.Utf8.parse(jsonData);

  // Apply PKCS7 padding automatically
  const encrypted = CryptoJS.AES.encrypt(data, keyBytesPython, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: ivPython,
  });

  // Convert to Base64
  const encryptedPayload = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  const ivBase64 = CryptoJS.enc.Base64.stringify(ivPython);

  return ivBase64 + ":" + encryptedPayload;
};

// AES-256-CBC Decryption
export const decryptJsonDataPython = (encryptedPayload) => {
  try {
    const parts = encryptedPayload.split(":");
    if (parts.length !== 2) {
      throw new Error("Invalid encrypted payload format");
    }

    const ivBase64 = parts[0];
    const encryptedDataBase64 = parts[1];

    // Decode IV and encrypted data from Base64
    const iv = CryptoJS.enc.Base64.parse(ivBase64);
    const encryptedData = CryptoJS.enc.Base64.parse(encryptedDataBase64);

    // Decrypt using AES-CBC
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedData },
      keyBytesPython,
      { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, iv: iv },
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    return error.message;
  }
};
export function toggleBoolean(value) {
  if (value === 1 || value === "1") return true;
  if (value === 0 || value === "0") return false;
  if (value === true) return 1;
  if (value === false) return 0;
  throw new Error("Invalid input");
}
export function formatDuration({
  years = 0,
  months = 0,
  weeks = 0,
  days = 0,
} = {}) {
  const parts = [];

  if (years) {
    parts.push(`${years} year${years > 1 ? "s" : ""}`);
  }
  if (months) {
    parts.push(`${months} month${months > 1 ? "s" : ""}`);
  }
  if (weeks) {
    parts.push(`${weeks} week${weeks > 1 ? "s" : ""}`);
  }
  if (days) {
    // Using "d" as the abbreviation for days as per your example
    parts.push(`${days}d`);
  }

  return parts.length ? parts.join(" ") : "N/A";
}

const getChatMessageText = (...values) => {
  for (const value of values) {
    if (Array.isArray(value)) {
      const firstValue = value.find((item) => !!item);
      if (firstValue) return firstValue;
      continue;
    }

    if (value) return value;
  }

  return "";
};

export const getPreciseChatTimestamp = (datetime) => {
  if (!datetime) return null;

  const normalizedDatetime = `${datetime}`.trim();
  if (!normalizedDatetime) return null;

  const preciseMatch = normalizedDatetime.match(
    /^(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})(?:\.(\d+))?$/,
  );

  if (preciseMatch) {
    const [, baseDatetime, fractionalSeconds = ""] = preciseMatch;
    const baseTimestamp = dayjs(
      baseDatetime,
      "YYYY-MM-DD HH:mm:ss",
      true,
    ).valueOf();

    if (!Number.isNaN(baseTimestamp)) {
      const fractionalMicroseconds = Number(
        fractionalSeconds.padEnd(6, "0").slice(0, 6),
      );
      return baseTimestamp * 1000 + fractionalMicroseconds;
    }
  }

  const fallbackTimestamp = dayjs(normalizedDatetime).valueOf();
  return Number.isNaN(fallbackTimestamp) ? null : fallbackTimestamp * 1000;
};

export const normalizeChatHistory = (chatHistory = []) => {
  const transformedData = [];

  chatHistory.forEach((historyItem = {}) => {
    const botMessage = historyItem?.bot || {};
    const userMessage = historyItem?.user || {};
    const messageKeyOrder = Object.keys(historyItem).filter(
      (key) => key === "bot" || key === "user",
    );
    const getMessageOrder = (messageType, fallbackOrder) => {
      const keyIndex = messageKeyOrder.indexOf(messageType);
      return keyIndex === -1 ? fallbackOrder : keyIndex;
    };
    const botQuestion = getChatMessageText(
      botMessage.masked_question,
      botMessage.question,
      botMessage.message,
    );
    const userReply = getChatMessageText(
      userMessage.masked_replay,
      userMessage.replay,
      userMessage.user_message,
      userMessage.cc_reply,
    );
    const historyItemMessages = [];

    if (
      botQuestion ||
      botMessage.uploaded_file ||
      (Array.isArray(botMessage.options) && botMessage.options.length > 0)
    ) {
      historyItemMessages.push({
        type: botMessage.type,
        answer: botMessage.answer,
        question: botQuestion,
        directionType: "receive",
        file_data: botMessage.uploaded_file,
        options: botMessage.options,
        cc_status: botMessage.cc_status,
        created_at: botMessage.datetime,
        datetime: botMessage.datetime,
        _localOrder: getMessageOrder("bot", 0),
      });
    }

    if (userReply || userMessage.uploaded_file) {
      historyItemMessages.push({
        replay: userReply,
        user_message: userReply,
        directionType: "send",
        file_data: userMessage.uploaded_file,
        created_at: userMessage.datetime,
        datetime: userMessage.datetime,
        _localOrder: getMessageOrder("user", 1),
      });
    }

    historyItemMessages.sort((messageA, messageB) => {
      const timestampA = getPreciseChatTimestamp(
        messageA.created_at || messageA.datetime,
      );
      const timestampB = getPreciseChatTimestamp(
        messageB.created_at || messageB.datetime,
      );

      if (
        timestampA === null ||
        timestampB === null ||
        timestampA === timestampB
      ) {
        return messageA._localOrder - messageB._localOrder;
      }

      return timestampA < timestampB ? -1 : 1;
    });

    transformedData.push(
      ...historyItemMessages.map(({ _localOrder, ...message }) => message),
    );
  });

  return transformedData;
};

export const handleGetChatHistory = async (url) => {
  let lamessageList = [];
  const response = await CallAPI("CHAT", "GET", url);
  console.log("response chat history---", response);
  response?.res?.data?.chat_histories_list.length > 0 &&
    response?.res?.data?.chat_histories_list?.forEach((chat) => {
      lamessageList.push(...normalizeChatHistory(chat.chat_details || []));
    });
  return lamessageList;
};

export const transformArrayToFlatObject = (data) => {
  return data.reduce((acc, item) => {
    acc[item.file_type] = item.file_link ?? "No File chosen";
    return acc;
  }, {});
};
